export default __webpack_public_path__ + "static/media/iniziative.2c5d06d3.png";